import React, { useState } from "react";
import { Button, Input, Select, Table, DatePicker, Col } from "antd";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";
import { SearchOutlined } from "@mui/icons-material";
import moment from "moment";

const Styleddiv = styled.div`
  .header-disciplinary {
    display: flex;
    justify-content: space-between;
  }
  .header-text {
    font-size: 20px;
    font-weight: 500;
  }
  .create-disciplinary {
    width: 170px;
    height: 40px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
  }
  .total-category {
    font-size: 16px;
    font-weight: 400;
  }
  .list-view {
    border: none;
    color: #2d53da;
    font-size: 16px;
    font-weight: 400;
  }
  .list-view:hover {
    background-color: #e3e8fc !important;
  }
  .all-field-style {
    display: flex;
    gap: 10px;
  }
  .searchbar {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
  .searchicon {
    color: #636980;
  }
  .date-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
  .date-dropdown:hover .ant-select-selector {
    border-color: #e2e2e8 !important;
  }
  .date-dropdown.ant-select-focused .ant-select-selector {
    border-color: #e2e2e8 !important;
  }
  .action-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
  .date-range-container {
    display: flex !important;
    gap: 10px;
  }
      .datepicker-style {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
`;

const CategoryView = ({ onBack, getDisData, disData }) => {
  const location = useLocation(); // Get location state
  const DispData = location.state?.DispData || [];
  const history = useHistory();
  const [searchText, setSearchText] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [showDateRange, setShowDateRange] = useState(false);

  const handleBackClick = () => {
    history.push("/disciplinary"); // Navigate back to the disciplinary page
  };

  const filterByDate = (data) => {
    const today = moment();
    return data.filter((item) => {
      const itemDate = moment(item.dateofincident, "YYYY-MM-DD");
      switch (selectedDateRange) {
        case "Last week":
          return itemDate.isBetween(today.clone().subtract(1, "weeks").startOf("week"), today.clone().subtract(1, "weeks").endOf("week"));
        case "Last month":
          return itemDate.isBetween(today.clone().subtract(1, "months").startOf("month"), today.clone().subtract(1, "months").endOf("month"));
        case "Last 6 months":
          return itemDate.isBetween(today.clone().subtract(6, "months").startOf("month"), today.clone().endOf("month"));
        case "Custom Date range":
          if (fromDate && toDate) {
            return itemDate.isBetween(fromDate, toDate, null, "[]");
          }
          return true;
        case "all":
        default:
          return true;
      }
    });
  };

  const filteredDispData = filterByDate(DispData).filter((item) =>
    item?.category?.toLowerCase()?.includes(searchText?.toLowerCase())
  );

  const categoryCount = filteredDispData.reduce((acc, item) => {
    acc[item.category] = (acc[item.category] || 0) + 1;
    return acc;
  }, {});

  const columns = [
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "No. of Employees",
      dataIndex: "no_of_employees",
      key: "no_of_employees",
    },
  ];

  const data = [
    {
      key: "1",
      category: "Absence from duty without permission",
    },
    {
      key: "2",
      category: "Unwillingness and inability to perform duties",
    },
    {
      key: "3",
      category: "Damage to Company property",
    },
    {
      key: "4",
      category: "Loss of Company property",
    },
    {
      key: "5",
      category: "Unauthorized possession of Company property",
    },
    {
      key: "6",
      category: "Insubordination",
    },
    {
      key: "7",
      category: "Use of abusive language, harassment, or bullying",
    },
    {
      key: "8",
      category: "Gross negligence",
    },
    {
      key: "9",
      category: "Wilful damage to or theft of company property",
    },
    {
      key: "10",
      category: "Fraud or dishonesty in dealing with the company",
    },
    {
      key: "11",
      category: "Theft or misappropriation of Company funds",
    },
    {
      key: "12",
      category: "Under drugs or alcohol during working hours",
    },
    {
      key: "13",
      category: "Noncompliance to standard operating procedure",
    },
  ]
    .map((item) => ({
      ...item,
      no_of_employees: categoryCount[item.category] || 0,
    }))
    .filter((item) => item.no_of_employees > 0); // Filter out categories with zero employees

  const handleSelectChange = (value) => {
    setSelectedDateRange(value);
    if (value === "Custom Date range") {
      setShowDateRange(true);
    } else {
      setShowDateRange(false);
      setFromDate(null);
      setToDate(null);
    }
  };

  const handleRowClick = (record) => {
    history.push({
      pathname: "/categorytable",
      state: { category: record.category, employees: filteredDispData.filter((emp) => emp.category === record.category) },
    });
  };

  return (
    <>
      <Styleddiv>
        <div>
          <div className="header-disciplinary">
            <div className="header-text">Disciplinary Management</div>
            <div></div>
          </div>
          <br />
          <div className="header-disciplinary">
            <div className="total-category">Total Category: {data.length}</div>
            <Button className="list-view" onClick={handleBackClick}>
              List View
            </Button>
          </div>
          <br />
          <div className="all-field-style">
            <div>
              <Input
                className="searchbar"
                placeholder="Search"
                prefix={<SearchOutlined className="searchicon" />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div>
              <Select
                placeholder="Date"
                className="date-dropdown"
                onChange={handleSelectChange}
                allowClear
              >
                <Select.Option value="Last week">Last week</Select.Option>
                <Select.Option value="Last month">Last month</Select.Option>
                <Select.Option value="Last 6 months">Last 6 months</Select.Option>
                <Select.Option value="Custom Date range">Custom Date range</Select.Option>
              </Select>
            </div>
            {showDateRange && (
              <div className="date-range-container">
                <Col>
                  <div>
                    <DatePicker
                      placeholder="From"
                      format="DD-MM-YYYY"
                      className="datepicker-style"
                      onChange={(date) => setFromDate(date)}
                    />
                  </div>
                </Col>
                <Col>
                  <div>
                    <DatePicker
                      placeholder="To"
                      format="DD-MM-YYYY"
                      className="datepicker-style"
                      onChange={(date) => setToDate(date)}
                      disabledDate={(current) =>
                        fromDate ? current && current.isBefore(fromDate, "day") : false
                      }
                    />
                  </div>
                </Col>
              </div>
            )}
          </div>
          <br />
          <div>
            <Table
              columns={columns}
              dataSource={data}
              pagination={false}
              onRow={(record) => ({
                onClick: () => handleRowClick(record),
              })}
            />
          </div>
        </div>
      </Styleddiv>
    </>
  );
};

export default CategoryView;
